/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sendresetemail2Inputs */

const en_sendresetemail2 = /** @type {(inputs: Sendresetemail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send Reset Email`)
};

const de_sendresetemail2 = /** @type {(inputs: Sendresetemail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link zum Zurücksetzen senden`)
};

/**
* | output |
* | --- |
* | "Send Reset Email" |
*
* @param {Sendresetemail2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const sendresetemail2 = /** @type {((inputs?: Sendresetemail2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sendresetemail2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sendresetemail2(inputs)
	return de_sendresetemail2(inputs)
});
export { sendresetemail2 as "sendResetEmail" }